import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SlaReducer(state = initialState.sla, action: any) {
  switch (action.type) {
    case types.SAVE_SLA_SUCCESS:
      return action.sla;
    default:
      return state;
  }
}
